// extracted by mini-css-extract-plugin
export default {"root":"FlfRow","content":"BSTAOc","card":"gAFl2M","topRightAction":"spaT1j","footerDivider":"wRu9FJ"};